import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-admin',
  templateUrl: './footer-admin.component.html',
  styleUrls: ['./footer-admin.component.sass']
})
export class FooterAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
